import { Component } from '@angular/core';

@Component({
  selector: 'app-coupon-header',
  templateUrl: './coupon-header.component.html',
  styleUrl: './coupon-header.component.scss'
})
export class CouponHeaderComponent {

}
